import { useMemo } from 'react';
import { get } from 'lodash';
import { StepSummaryLabel } from './step-summary/step-summary-label';
import { StepSummaryContent } from './step-summary/step-summary-content';
import { StepSummaryActions } from './step-summary/step-summary-actions';
import { StepAgendaLabel } from './step-agenda/step-agenda-label';
import { StepAgendaContent } from './step-agenda/step-agenda-content';
import { stepAgendaSchema } from './step-agenda/step-agenda-schema';
import { StepOriginatorLabel } from './step-originator/step-originator-label';
import { StepOriginatorContent } from './step-originator/step-originator-content';
import { stepOriginatorSchema } from './step-originator/step-originator-schema';
import { ProfileForm } from '../profile/profile-types';
import { StepSubjectLabel } from './step-subject/step-subject-label';
import { StepSubjectContent } from './step-subject/step-subject-content';
import { stepSubjectSchema } from './step-subject/step-subject-schema';
import { StepFinishLabel } from './step-finish/step-finish-label';
import { StepFinishContent } from './step-finish/step-finish-content';
import { EmptyComponent } from '@eas/common-web';

function disableFieldIfFilled(
  arr: string[],
  profile: ProfileForm,
  profilePath: string,
  fieldName: string
) {
  if (get(profile, profilePath)) {
    arr.push(fieldName);
  }
}

export function useUFormRequests(profile: ProfileForm) {
  const disabledFields: string[] = [];

  disableFieldIfFilled(
    disabledFields,
    profile,
    'firstName.value',
    'actor.firstName'
  );
  disableFieldIfFilled(
    disabledFields,
    profile,
    'lastName.value',
    'actor.lastName'
  );
  disableFieldIfFilled(
    disabledFields,
    profile,
    'birthDate.value',
    'actor.birthDate'
  );
  disableFieldIfFilled(
    disabledFields,
    profile,
    'identityDocuments[0].idNumber.value',
    'actor.idNumber'
  );
  disableFieldIfFilled(disabledFields, profile, 'isdsIds[0]', 'actor.databox');
  disableFieldIfFilled(disabledFields, profile, 'residence', 'actor.address');

  const steps = useMemo(
    () => [
      {
        Label: StepAgendaLabel,
        Content: StepAgendaContent,
        validationSchema: stepAgendaSchema,
      },
      {
        Label: StepOriginatorLabel,
        Content: StepOriginatorContent,
        validationSchema: stepOriginatorSchema,
        initialValues: {
          actor: {
            firstName: profile?.firstName?.value || '',
            lastName: profile?.lastName?.value || '',
            birthDate: profile?.birthDate?.value,
            idNumber: profile?.identityDocuments?.[0]?.idNumber?.value || '',
            databox: profile?.isdsIds?.[0] || undefined,
            address: profile?.residence || {},
          },
        },
        disabledFields,
      },
      {
        Label: StepSubjectLabel,
        Content: StepSubjectContent,
        validationSchema: stepSubjectSchema,
      },
      {
        Label: StepSummaryLabel,
        Content: StepSummaryContent,
        Actions: StepSummaryActions,
      },
      {
        Label: StepFinishLabel,
        Content: StepFinishContent,
        Actions: EmptyComponent,
      },
    ],
    [profile]
  );

  return { steps };
}
